import { Rating, RatingProps } from '@mui/material';
import React from 'react';
import styled from 'styled-components';
import { FormPublicDesignFragment } from '../../graphql/fragment/form.public.fragment';
import { lighten } from 'polished';
interface Props {
  field: any;
  design: FormPublicDesignFragment;
  onChange: any;
  value: number;
  children?: any;
  name: string;
  id: string;
}

const Field = styled(Rating)<{ design: FormPublicDesignFragment }>`
  &.MuiRating-root.MuiRating-sizeLarge {
    font-size: calc(6vw);
  }
  &.MuiRating-root.MuiRating-sizeLarge {
    @media screen and (max-width: 600px) {
      font-size: calc(12vw);
    }
    @media screen and (min-width: 600px) {
      font-size: calc(4vw);
    }
    margin-bottom: 3vh;
  }
  & .MuiRating-iconEmpty {
    & .MuiSvgIcon-root.MuiSvgIcon-fontSizeInherit {
      fill: ${({ design }) => lighten(0.2, design.colors.background)};
    }
  }

  & .MuiRating-iconFilled {
    & .MuiSvgIcon-root.MuiSvgIcon-fontSizeInherit {
      fill: ${({ design }) => design.colors.button};
    }
  }
`;

export const RadioStyledInput: React.FC<Props & RatingProps> = ({
  children,
  ...props
}) => {
  return (
    <Field precision={0.5} size='large' {...props}>
      {children}
    </Field>
  );
};
